import api from '@/api/services/api'

const getCollection = params => api({
  baseURL: 'https://test1.online-express.ru/api/',
  method: 'get',
  url: 'tours/search',
  params
})

const getTour = params => api({
  baseURL: 'https://test1.online-express.ru/api/',
  method: 'get',
  url: 'tours/cart',
  params
})

const getAccommodations = params => api({
  baseURL: 'https://test1.online-express.ru/api/',
  method: 'get',
  url: 'tours/hotels',
  params
})

const getFlights = params => api({
  baseURL: 'https://test1.online-express.ru/api/',
  method: 'get',
  url: 'tours/flights',
  params
})

const getTransfers = params => api({
  baseURL: 'https://test1.online-express.ru/api/',
  method: 'get',
  url: 'tours/transfers',
  params
})

export {
  getCollection,
  getTour,
  getAccommodations,
  getFlights,
  getTransfers
}